import { Storage } from "@packages/util";

type StorageType = {
  sb: boolean;
  token: string;
};

const storage = new Storage<StorageType>();

export default storage;
